import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import ChangeDatasourceCodeForm from './form'

const ChangeDatasourceCodeDialog = React.forwardRef(function ChangeDatasourceSchemaDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (dataSource) => setDialogState({
      open: true,
      processing: false,
      dataSource
    })
  }), [setDialogState])

  return (
    <SydModal
      title='Change Datasource Code'
      open={dialogState.open}
      onClose={close}
      size='lg'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <ChangeDatasourceCodeForm
            dataSource={dialogState.dataSource}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

ChangeDatasourceCodeDialog.propTypes = {
  onComplete: PropTypes.func
}

ChangeDatasourceCodeDialog.defaultProps = {
  onComplete: () => {}
}

export default ChangeDatasourceCodeDialog
